/*
 * @Author: Dzy
 * @Date: 2022-07-21 20:10:55
 * @LastEditors: Dzy
 * @LastEditTime: 2022-09-23 10:50:37
 * @Description: token信息存储 localStorage
 */
import { defineStore } from 'pinia'

export const useTokenStore = defineStore('userTokenBusi', {
  state: () => {
    return {
      accessToken: '',
      expiresIn: '',
      refreshToken: '',
      tokenType: ''
    }
  },

  actions: {
    update_token(data) {
      this.accessToken = data.access_token
      this.expiresIn = data.expires_in
      this.refreshToken = data.refresh_token
      this.tokenType = data.token_type
    }
  },
  // 所有数据持久化 插件其他配置
  persist: true
})
